import type { HttpServiceModelBase } from '@/types'
import { defaultServiceModel } from '@/views/builder/utils/defaultServiceModel'

// HTTP, HTTP Paging and Webhook start these five settings with the same values, so one starting model serves all three.
const STARTING_MODEL = defaultServiceModel('http') as HttpServiceModelBase

/**
 * How many settings in the HTTP editor's Advanced area the author has set: each of the five settings that differs
 * from the value a new service starts with, plus Filter when when it holds text.
 */
export function advancedCount(model: HttpServiceModelBase, filterWhen: string): number {
  const changedSettings = [
    model.requestTimeout !== STARTING_MODEL.requestTimeout,
    model.httpVersion !== STARTING_MODEL.httpVersion,
    model.regardHttpErrorAsFatal !== STARTING_MODEL.regardHttpErrorAsFatal,
    model.requestIsRepeatable !== STARTING_MODEL.requestIsRepeatable,
    model.disableChunking !== STARTING_MODEL.disableChunking,
  ]
  const filterIsSet = filterWhen.trim() !== ''
  return changedSettings.filter(Boolean).length + Number(filterIsSet)
}
